<template>
    <blog-listings-section
        class="blog-listings-section-module"
        :blogs="blogPosts"
        :current-page="currentPage"
        :total-pages="totalPages"
    />
</template>

<script>
    import BlogListingsSection from '../../../organisms/BlogListingsSection/BlogListingsSection';

    export default {
        name: 'blog-listings-section-module',

        components: { BlogListingsSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        async asyncData({ store, query }) {
            const currentPage = parseInt(query.page || 1);

            const locale = store.state.locales.locales.find(({ code }) => code === store.state.locales.locale ?? 'en')?.code;

            const { blogPosts } = await store.dispatch('blogs/getBlogPosts', {
                page: currentPage,
                locale,
            });

            return {
                blogPosts,
                currentPage,
            };
        },

        data() {
            return {
                blogPosts: this.attributes.asyncData.blogPosts?.data || [],
                currentPage: this.attributes.asyncData.currentPage,
            };
        },

        computed: {
            /**
             * Get total pages.
             *
             * @returns {number}
             */
            totalPages() {
                return this.attributes.asyncData.blogPosts
                    ?.pagination
                    ?.pageCount;
            },
        },

        watch: {
            /**
             * Fetch additional blog posts on route query page change.
             */
            '$route.query.page': 'fetchBlogPosts',
        },

        methods: {
            /**
             * Fetch prev/next page of blog posts.
             */
            async fetchBlogPosts() {
                const { blogPosts } = await this.$options.asyncData({
                    store: this.$store,
                    query: this.$route.query,
                });

                this.blogPosts = blogPosts.data;

                this.currentPage = parseInt(this.$route.query.page || 1);
            },
        },
    };
</script>
